import styled from 'styled-components'
import { Badge } from '@mui/material'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 120px;
  padding: 12px;
  border-radius: 12px;
  border: 2px solid ${({ isSelected }) => (isSelected ? '#E27837' : '#D6D7DB')};
  cursor: pointer;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`

const CaffeinePressable = ({
  timesPressed = null,
  onClick,
  imgOption,
  nameOption,
  isSelected,
  disableOptions,
  caffeineQty,
}) => {
  return (
    <Badge
      color='primary'
      invisible={!isSelected}
      badgeContent={timesPressed ? timesPressed : ''}
    >
      <Container
        onClick={onClick}
        isSelected={isSelected}
        disabled={disableOptions && !isSelected}
      >
        <div>{imgOption}</div>
        <ContentContainer>
          <span style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
            {nameOption}
          </span>
          {caffeineQty && (
            <span style={{ fontSize: 12, textAlign: 'center' }}>
              {caffeineQty}
            </span>
          )}
        </ContentContainer>
      </Container>
    </Badge>
  )
}

export default CaffeinePressable
